import React from 'react';
import Button from '@/components/ui/Button';
import { ReportType } from '@/pages/reports/ReportsPage/types';
import { reportsV2API } from '@/services/api/reportsV2';
import { downloadBlob } from './downloadBlob';

const ReportExportButton: React.FC<{ workspaceId: string; type: ReportType; id: string }> = ({ workspaceId, type, id }) => {
  const [busy, setBusy] = React.useState(false);
  const [status, setStatus] = React.useState<'idle' | 'success' | 'error'>('idle');
  const errorRef = React.useRef<HTMLParagraphElement>(null);
  React.useEffect(() => { if (status === 'error') errorRef.current?.focus(); }, [status]);
  const download = async () => {
    setBusy(true);
    setStatus('idle');
    try {
      const blob = await reportsV2API.exportDetail(workspaceId, type, id);
      downloadBlob(blob, `${type}-report-${id}.csv`);
      setStatus('success');
    } catch {
      setStatus('error');
    } finally { setBusy(false); }
  };
  return <div><Button variant="outline" loading={busy} loadingLabel="Exporting reports" onClick={() => { void download(); }}>Export CSV</Button>{status === 'success' && <span className="sr-only" role="status">Report export downloaded.</span>}{status === 'error' && <p ref={errorRef} role="alert" tabIndex={-1} className="mt-2 max-w-64 text-sm text-red-700 dark:text-red-300">Unable to export this report. Try again.</p>}</div>;
};
export default ReportExportButton;
